import React from "react";
import "./A1Page.css";
const A1CourseDetails = () => {
  return (
    <div className="a1DetailsContainer">
      <ul>
        <li>It is the Beginner’s Level course.</li>
        <li>Learn the Alphabets, Numbers and Pronunciation</li>
        <li>Entire course covers Theme based Topics</li>
      </ul>
      <h3>What to expect after completion of this course?</h3>
      <ul>
        <li>
          After completion of course, you can confidently introduce yourself in
          German.
        </li>
        <li>
          You can conduct the basic conversations in day-to-day life in Germany.
        </li>
        <li>Making an Appointment in German becomes easy.</li>
        <li>Ordering Food in Cafes and Restaurants.</li>
        <li>Conversations in a Supermarket or a shopping mall</li>
        <li>Understanding Announcements at Railway Stations or Airports</li>
        <li>
          You can plan different events like vacations, birthdays and organizing
          parties.
        </li>
        <li>You will be able to give commands, orders and instructions.</li>
        <li>
          Asking for and giving Information at different places like Railway
          Stations or Airports.
        </li>
        <li>Asking the Way and Giving Directions</li>
        <li>
          With A1 level, it becomes easier to spend a short period of time in
          Germany.
        </li>
      </ul>
    </div>
  );
};

export default A1CourseDetails;
